module.exports = __webpack_public_path__ + "static/media/trash.16e6a307.svg";